<template>
	<div>
		<div style="height: 80px;"></div>
		<div style="background: #F8F8F8; height: 30px;line-height: 30px;">
			<div class="container">
				首页 > 新闻中心 > 企业动态 > 文章详情
			</div>
		</div>
		<!-- 新闻内容 -->
		<div class="container">
			<div style="height:  15px;"></div>
			<div class="pcpadding" style="background-color: white;width: 100%;">
				<!-- 标题 -->
				<div style="color: #333333;font-weight: bold;font-size: 39px;line-height: 59px;">
					星链C2M赋能鞋业突围
				</div>
				<!-- 时间 -->
				<div style="height: 25px;"></div>
				<div class="context_tiem alibabapuhuiti_bold">
					2022-04-01
				</div>

				<!-- 新闻内容 -->
				<div style="height: 35px;"></div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					浙江星链数据科技有限公司（简称星链数据）将互联网、大数据、云计算、人工智能等新一代信息技术与制造业、零售业深度融合，探索C2M
					智能定制平台模式，为鞋业从制造端到零售终端的全产业链赋能，助力鞋企由标准化批量生产向个性化按需生产转变。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					困境和机遇催生鞋业C2M
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					改革开放以来，我国鞋业迅猛发展，早已成为全球第一大鞋类产品制造、消费和出口国。然而，近年来，我国鞋业开始面临产能过剩、产品同质化、模式固化的困境。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					困境一：产能过剩
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					相关统计数据显示，2019年全球鞋类总产量约243亿双，其中，中国鞋类产量达134.8亿双，占全球总产量的55.5%。在产量快速增长的同时，我国鞋类产品出口增长乏力，内销订单量持续下降。2020年，受中美贸易摩擦和新冠肺炎疫情双重影响，大量鞋类出口产品转内销，导致我国鞋业产能严重过剩，鞋企及渠道库存大量积压。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					困境二：产品同质化
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					过去15年间，国内鞋企由1万多家迅速发展到3万多家，其中大多是品牌意识淡薄、技术水平低、缺乏自主创新能力的中小型企业，鞋企之间互相模仿，导致产品同质化现象严重。一位鞋企老总感叹：“只要市场上出现一款畅销产品，用不了几天，便会有众多鞋企跟风模仿。在一条商业街上，如果把所有鞋类产品的商标撕掉，几乎认不出是哪个品牌。”
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					产品同质化直接后果就是低价竞争，鞋企之间大打价格战，挤压了行业原本就微薄的利润空间。有的鞋企为了争市场、
					去库存，甚至不惜“赔钱赚吆喝”，导致行业陷入“低价血拼－企业亏损－研发投入乏力－质量下降－品牌力式微”的恶性循环。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					困境三：模式固化
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					多年来，我国鞋业通过把耐用品做成“快消品”，一直在享受“以产定销”的标准化、大规模产销模式下的红利，“品牌建设”和“商业模式创新”也大多停留在炒作概念、变换花样搞促销层面。面对着互联网快速发展带来的电商平台崛起以及消费者多元化、个性化和高品质服务的需求，鞋企们蓦然发现自身并未构建起适应新时代需求的核心竞争力和永续经营的商业模式，只能在同质化恶性竞争的“红海”中苦苦挣扎。广东和浙江是国内主要鞋业产区，近年来，广东5000多家鞋企中已有1000多家倒闭，浙江温州的3200多家鞋企中已有近半关门歇业。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					面对产业困境，一家致力于为鞋业提供C2M智能定制一站式解决方案的科技型企业——星链数据敏锐地捕捉到了传统鞋企突围自救、转型发展的新机遇。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					C2M（Customer to
					Manufactory，即顾客直达工厂）是一种基于工业互联网的新型电子商务商业模式，即按需生产和服务，实现产品需求端（顾客）与制造端（工厂）直接连通。星链数据认为，新兴技术发展、消费需求变化，既是挑战，更是机遇。将互联网、大数据、云计算、人工智能等新一代信息技术与制造业、零售业深度融合，贯通产业链上下游，让顾客直达工厂、产品直达顾客的C2M模式，是鞋业突围转型、创新发展的必然选择。
				</div>
				<img style="width: 100%;" src="../../static/news/3/1.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					“云端互联”搭建C2M平台
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					星链数据在长期跟踪调研和深度实践基础上，整合积累了丰富的鞋业信息资源，经过五代技术开发和产品实验，搭建了“一体两翼，一云四端”鞋业C2M智能定制产业互联网平台。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					“一体两翼”的前翼是智能定制，后翼是智能制造（如图1所示）。“一云”指C2M大数据云平台，包括定制云平台和供应链云平台；“四端”指定制零售端、系统集成端、数字研发端、智能制造端（如图2所示）。
				</div>
				<img style="width: 100%;" src="../../static/news/3/2.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					C2M大数据云平台是星链C2M智能定制平台的核心，主要功能是负责相关数据的提取、加工、传输、应用和储存，通过定制云平台和供应链云平台的数据积累、沉淀和协同应用，实现需求侧与供给侧精准匹配。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					在星链C2M大数据云平台上，一双鞋需要的数据主要有六类，即顾客脚型数据、楦型数据、款型数据、工序数据、工艺数据和材料数据。顾客脚型数据可以由定制顾问上门采集或顾客到终端门店智能量脚；顾客量完脚、选好鞋款后，平台通过数字研发端自动将顾客脚型、楦型和鞋款进行精准匹配；顾客下订单后，工序数据、工艺数据和材料数据由智能制造端的定制工厂直接提取应用，系统集成端对这些数据进行点对点、端到端的无缝连接。与传统生产模式相比，星链C2M可以帮助鞋企提高一倍以上的生产效率。
				</div>
				<img style="width: 100%;" src="../../static/news/3/3.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					C2M定制云平台是星链数据通过全渠道网络为顾客服务的平台。顾客可通过终端门店以及天猫、严选、微信等互联网平台输入个人数据直接下单定制，还可以通过星链自主研发的“V品定制”小程序预约上门量脚下单。各类渠道的订单数据，都会通过定制零售端和数字研发端传输至星链大数据云平台进行统一处理应用。如星链数据为奥康鞋业量身定制的C2M解决方案，顾客可通过奥康鞋业线下门店和“奥康优品”线上商城下单定制，也可以由门店客服预约上门定制，顾客定制的订单数据通过C2M大数据云平台进行统一处理与转化。奥康鞋业通过这种全渠道、全场景的定制化服务，拓宽了与顾客的接触面，大大增加了获客机会，增强了顾客黏性。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					在星链C2M供应链云平台上，系统可通过3D脚型测量仪采集顾客多达39个脚型数据，并自动向顾客推荐最佳鞋款。顾客下单后，脚型及订单数据通过大数据云平台传输至供应链云平台，系统自动筛选与顾客需求相匹配的工厂，并自动生成顾客订单所需要的皮料、底料、辅料、配饰以及DIY材料等信息。星链C2M改变了传统鞋企以产定销的高库存模式，用户定多少，工厂就生产多少，真正实现了产品零库存。顾客下单后，可在手机移动端全程跟踪订单与产品生产、配送全过程。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					一位与星链数据合作的广东鞋企老板表示：“习惯了按传统方式生产，刚开展C2M定制业务时感觉不适应，以前是先生产后销售，现在是先有订单再生产，订单计划、备料计划、排产计划等都是反着来的，但是现在已经习惯了。C2M模式最大的好处是从过去盲目生产到现在精准生产，大部分产品实现了零库存，不仅生产效率提升一倍以上，而且提高了产品附加值。”
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					四大特色激发鞋业发展新动能
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					星链数据在C2M平台建设和模式创新上投入了大量的人力、财力、物力，在深入研究洞察鞋业运作规律和发展趋势的基础上，以实现需求侧与供给侧的精准匹配、产业资源与社会资源应用效益最大化为目标，通过探索解决行业痛点和产业链关键环节堵点问题，寻求突破，形成了四大特色。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					特色一：产业互联助行业
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					公司创立前期，星链数据投资1000多万元研发迭代了四代智能脚型测量仪、脚型算法转化系统和定制零售管理系统，专为采集顾客脚型数据和定制化消费使用。顾客脚型数据通过C2M大数据云平台，可以直接传递到工厂端，工厂根据顾客的专属脚型生成对应脚楦，为顾客提供个性化的定制产品，在大幅减少人工成本的同时，提高了定制的精准度和效率。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					近年来，星链数据相继投入6000多万元，自主研发了C2M“一体两翼”
					产业互联定制平台，包括脚型健康大数据系统（云脚库、云楦库、云品库、云工厂）、DDP数字研发系统、脚楦数据算法转换系统、CBS定制业务系统、SRM定制零售系统、CRM客户关系管理系统、产品订单可视化系统、MES智能制造系统、SCM供应链管理系统、PLM产品生命周期跟踪管理系统等。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					为了让顾客更好地体验预约上门定制服务，星链数据2020年投入800多万元，应用AI算法自主研发出支持上门定制的第五代智能脚型扫描仪，并通过累计50多万次的男女鞋脚型测量试验，建立了适合中国人脚型的大数据库。同年，星链数据又开发出“V品定制”线上定制平台，支持线上线下全域定制。这一创新成果让鞋履定制不再受时间和空间的限制，可以为顾客提供随时随地、随人随款的个性化定制服务。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					截至目前，星链数据已为50多家鞋企提供了C2M智能定制整体解决方案，计划两年内帮助100家鞋企实现C2M定制模式，赋能3000家鞋业零售商开展定制业务。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					特色二：反向定购零库存
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					工业化时代，工厂以标准化、流水线、大规模生产的方式来提高产量、降低生产成本，通过市场预测进行计划性生产，再通过层层经销和分销将产品传递给消费者，即工厂生产什么，商家就卖什么，消费者只能买什么。在当今供给过剩的时代，企业需要满足消费者多元化、个性化的需求，即消费者需要什么，商家就要卖什么，工厂就得生产什么。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					星链C2M智能定制模式的创新特色就在于实现了以销定产、反向定购零库存的低成本、轻资产、柔性化生产。顾客在零售终端完成量脚、试穿、选款和结算后，大数据云平台自动将顾客的脚型数据和产品数据传输至对应工厂；工厂接到订单后，根据顾客的脚型特征和产品属性需求进行柔性生产。星链C2M“反向定购”模式（如图3所示）是从消费者需求出发，通过流通渠道向供应端延伸，有效避免了工厂盲目生产导致的产能过剩、商家盲目进货造成的库存积压；同时，去掉了中间商层层加价环节，让顾客直达工厂、产品直达顾客，助力企业快速反应市场需求。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					应用星链C2M智能定制模式的鞋企均以反向定购业务模式替代了过去的以产定销模式，逐步从产品同质化、低价竞争的“红海”中突围，走上了生产低成本、产品高附加值、运营高效率的差异化发展道路。
				</div>
				<img style="width: 100%;" src="../../static/news/3/4.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					特色三：智能定制更高效
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					传统的鞋履定制模式是手工量脚和手工制作，存在四个主要问题：一是手工量脚存在误差，脚型数据很难统一；二是顾客脚型难以建立系统化的数据库，导致生产成本过高；三是手工制作费工、费力、费时，订单交期过长；四是难以实现规模化生产。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					星链数据通过自主研发的AI智能脚型扫描仪，可以5秒完成脚型扫描、20秒自动生成数据、1分钟完成一键定制、10分钟完成派单计划。根据顾客订单紧急情况及产品难易程度，可以在一两周内完成产品交付。整个定制过程均通过数据交互完成，在降低人工成本的同时，大大提高了运营效率。如应用星链C2M的奥康鞋业在每个终端门店辟出10~15平方米场地，作为定制服务专区，门店坪效提升20%~30%，毛利率提升15%~20%。
				</div>
				<img style="width: 100%;" src="../../static/news/3/5.png"></img>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					特色四：个性定制差异化
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					星链C2M为顾客开创了全渠道、全场景的个性化、定制化消费体验。无论是顾客在家、办公室，还是在酒店，只需打开“V品定制”小程序，点击“预约定制”，LBS系统就会自动匹配就近的定制顾问上门为顾客采集脚型数据，并搭配适合的鞋款提供定制服务。顾客也可以通过“V品定制”平台小程序搜索附近的定制门店，去现场体验个性化智能定制服务；还可以根据自己的脚型及个性化需求，在“V品定制”平台上选择定制参数，进行在线定制。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					通过上门定制、门店定制、云店定制，星链C2M实现了全渠道、全场景、全链路的个性化智能定制模式，可以随时随地为顾客提供定制服务。针对有的顾客因左右脚型差异选鞋难、穿鞋痛的难点，以及顾客DIY的个性化需求等，星链C2M可以为顾客提供“一脚一楦”的专属定制服务。顾客还可以针对某一鞋款，选择自己喜欢的面料、底料、辅料、配饰和颜色，参与到鞋子最初的设计环节当中，并通过定制可视化系统，全程关注鞋子的生产过程。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
				这种个性化定制还解决了特殊脚型人群选鞋难、新鞋穿着不舒适的痛点。星链C2M大数据云平台脚型数据显示，70%的人左右脚型存在差异，25%的人左右脚型存在明显差异，还有5%的人左右脚型存在较大差异。曾有一位顾客左右脚长度一样，足弓相当，但右脚指维和背维比左脚整整大一圈，按照鞋码算要大1.5码。因此，这位顾客必须按照右脚的肥度买鞋子，但左脚穿起来就会感觉松垮，即“不跟脚”。星链C2M智能定制门店根据这位顾客的脚型差异特点，对其脚型进行多维测量，并将相关数据上传至C2M大数据云平台进行精准计算画像，采取“一脚一楦”“一鞋一码”的方式为其定制。穿上星链C2M智能定制的鞋子后，这位顾客说：“虽然看起来右脚的鞋子比左脚大，但走起路来舒服多了。”还有一位顾客左脚长但比右脚瘦，右脚短一点但比左脚肥，按照标准码买的鞋子适合了一只脚就不能适合另一只脚，星链C2M智能定制让其终结了多年来将就着穿鞋的历史。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
			鞋子合不合适只有脚知道
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					江河中的前浪必然被后浪淹没，技术革命带来的新时代必将淘汰一个个旧物种，同时催生新物种。许多划时代的新物种出现，对人们的生产生活乃至经济社会发展产生着深刻影响。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					在互联网、大数据、云计算、人工智能等新一代信息技术快速发展的今天，中国制造只有向“中国智造”转型升级，才能不断满足人们日益增长的追求品质生活和个性化消费的需求。星链C2M为“中国智造”提供了一个探索和实践的样本。然而，俗话说“鞋子合不合适只有脚知道”，包括鞋业在内的各行各业深入应用C2M模式，仍面临着一定的挑战，C2M的普惠性和模式演进仍有很长的路要走。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					首先，深入应用C2M模式需要从改变认知开始。只有时代的成功企业，没有成功企业的时代。随着传统制造模式红利逐渐消失，那种“一招鲜，吃遍天”的时代已经一去不复返。企业只有坚持以市场为导向、顾客为中心，将新兴技术与自身生产经营实践相结合，与时俱进地不断创新，才能在激烈的市场竞争中立于不败之地。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					其次，C2M反向定购零库存模式需要解决大规模生产与个性化定制模式的背向冲突。传统制造模式的优势在于规模化、标准化，而C2M模式注重个性化、智能化、柔性化、定制化。企业要将传统的“以产定销”模式下的材料采购、产品开发、产品打样、产品订货、批量生产等，转变为按需采购、按需排单、按需生产、按需供应的“反向定购”模式，将是对生产经营各个环节的考验。C2M模式对企业的产品开发创新能力、生产经营组织形式、运营管理流程等都带来了很大挑战，需要对企业整个供应链及运营流程进行全面系统的变革。
				</div>
				<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
					再次，C2M模式需要更精准地了解、挖掘、洞察并满足顾客个性化需求。顾客的消费诉求在很大程度上是模糊不清的，这就要求企业在生产产品前精准了解顾客需求，否则生产出来的产品将很难达到顾客的期望值。此外，企业能否在约定时间内将定制产品送达顾客，对于顾客满意度至关重要，也关系到产品定制最终是否成功。这就要求企业变革生产流程和工序、完善端到端的物流服务，缩短产品交付期，才能最终提升顾客对定制体验的满意度。
				</div>
	<div class="context_tiem" style="text-indent: 2em;line-height :35px;letter-spacing:1px;">
			作者单位 浙江星链数据科技有限公司	</div>
				<!-- 新闻内容end -->


			</div>
			<div style="height:  45px;"></div>
		</div>
		<!-- 新闻内容 end -->


	</div>
</template>
<script>
	export default {
		name: 'Newdetails3',
		components: {


		},
		data() {
			return {

			}
		},

	}
</script>

<style>
	.context_tiem {
		color: #5D8299;
		size: 17px;
	}
	@media (min-width: 1000px) {
		.pcpadding {
			padding: 55px 200px 55px 200px;
		}
	}
</style>
